export const WITHDRAWN_NICKNAME_SUFFIX = '(탈퇴)';
export function withdrawnDisplayNickname(originalNickname) {
    return `${originalNickname}${WITHDRAWN_NICKNAME_SUFFIX}`;
}
export function isWithdrawnNickname(nickname) {
    return typeof nickname === 'string' && nickname.endsWith(WITHDRAWN_NICKNAME_SUFFIX);
}
//# sourceMappingURL=withdrawn-nickname.js.map